module.exports = __webpack_public_path__ + "img/feedback.cdb0d56e.png";